<template>
  <div :class="containerClass" @click="onWrapperClick">
    <AppTopBar @menu-toggle="onMenuToggle" />
    <transition name="layout-sidebar">
      <div :class="sidebarClass" @click="onSidebarClick" v-show="isSidebarVisible()">
        <div class="layout-logo">
          <router-link to="/">
            <img alt="Logo" :src="logo" />
          </router-link>
        </div>
        <div class="layout-profile">
          <router-link to="/admin">
            <span class="" style="color:white">{{username}}</span>
          </router-link>
          <!-- <a href="#" class="username username-custom">{{username}}</a> -->
        </div>
        <!-- <AppProfile /> -->

        <AppMenu :model="menu" @menuitem-click="onMenuItemClick" />
      </div>
    </transition>
    <div class="admin-layout layout-main">
      <router-view />
      <Dialog
        id="loadingDialog"
        :visible.sync="$store.getters.isLoading"
        :modal="true"
        :closable="false"
        :showHeader="false"
      >
        <ProgressSpinner style="width:50px;height:50px" />
      </Dialog>
    </div>
    <Toast position="bottomright"/>
    <AppFooter />
  </div>
</template>
<script>
import AppTopBar from './layout/Topbar';
// import AppProfile from './layout/Profile';
import AppMenu from './layout/Menu';
import AppFooter from './layout/Footer';
import store from '@/store'
import DataServices from '@/core/DataServices'
export default {
  name: 'AdminLayout',
  components: {
    'AppTopBar': AppTopBar,
    // 'AppProfile': AppProfile,
    'AppMenu': AppMenu,
    'AppFooter': AppFooter
  },
  computed: {
    containerClass() {
      return ['layout-wrapper', {
        'layout-overlay': this.layoutMode === 'overlay',
        'layout-static': this.layoutMode === 'static',
        'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
        'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
        'layout-mobile-sidebar-active': this.mobileMenuActive
      }];
    },
    sidebarClass() {
      return ['layout-sidebar', {
        'layout-sidebar-dark': this.layoutColorMode === 'dark',
        'layout-sidebar-light': this.layoutColorMode === 'light'
      }];
    },
    logo() {
      return (this.layoutColorMode === 'dark') ? "../../../assets/layout/images/logo.png" : "../../../assets/layout/images/logo.png";
    }
  },
  beforeUpdate() {
    if (this.mobileMenuActive)
      this.addClass(document.body, 'body-overflow-hidden');
    else
      this.removeClass(document.body, 'body-overflow-hidden');
  },
  mounted () {
    if(this.$route.params.reload) {
      window.location.reload();
    }
    var open = localStorage.getItem('isOpen');
    if (open === undefined || !open) {
      this.staticMenuInactive = false;
    } else {
       this.staticMenuInactive = true;
    }
  },
  watch: {
    $route() {
      this.menuActive = false;
    }
  },
  methods: {
    onWrapperClick() {
      if (!this.menuClick) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
      this.menuClick = false;
    },
    onMenuToggle() {
      this.menuClick = true;

      if (this.isDesktop()) {
        if (this.layoutMode === 'overlay') {
          this.overlayMenuActive = !this.overlayMenuActive;
        }
        else if (this.layoutMode === 'static') {
          this.staticMenuInactive = !this.staticMenuInactive;
        }
      }
      else {
        this.mobileMenuActive = !this.mobileMenuActive;
      }

      event.preventDefault();
    },
    onSidebarClick() {
      this.menuClick = true;
    },
    onMenuItemClick(event) {
      // var open = localStorage.getItem('isOpen');
      // if (open === undefined  || !open) {
      //   localStorage.setItem('isOpen', true);
      // } else localStorage.setItem('isOpen', false);
      // console.log('event', event);
      if (event.item && !event.item.items) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
        if(this.$route.path !== event.item.to) {
          var info = this.$router.resolve(event.item.to)
          this.$router.push({name: info.route.name, params: {reload: true}})
        }
      }
    },
    addClass(element, className) {
      if (element.classList)
        element.classList.add(className);
      else
        element.className += ' ' + className;
    },
    removeClass(element, className) {
      if (element.classList)
        element.classList.remove(className);
      else
        element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    },
    isDesktop() {
      return window.innerWidth > 1024;
    },
    isSidebarVisible() {
      if (this.isDesktop()) {
        if (this.layoutMode === 'static')
          return !this.staticMenuInactive;
        else if (this.layoutMode === 'overlay')
          return this.overlayMenuActive;
        else
          return true;
      }
      else {
        return true;
      }
    },
    show_list_menu(e) {
      console.log("store.getters.group_permission:",store.getters.group_permission)
      if ((store.getters.group_permission && store.getters.group_permission[e] && store.getters.group_permission[e].list == true) || store.getters.role == "admin") {
        console.log(e+":false")
        return false
      } else {
        console.log(e+":true")
        return true
      }
    },
    show_list_menu_admin(key) {
      console.log("store.getters.role:",store.getters.role)
      if (store.getters.role == "court") {
           if (key=='parent_doc'){
             return false;
           }else {
             return true
           }
      }else {
        if (store.getters.role == "admin") {
          return false
        } else {
          if (store.getters.role == "dpv") {
            var list_key_dislay = ['parent_doc','parent_salary','parent_pricelist','parent_setting_pricelist','parent_report','parent_user','parent_system'];
            if (list_key_dislay.indexOf(key) ==-1){
              return true;
            }else {
              return false;
            }
          }
          return true;
        }
      }
    }
  },
  data() {
    return {
      layoutMode: 'static',
      layoutColorMode: 'dark',
      staticMenuInactive: false,
      overlayMenuActive: false,
      mobileMenuActive: false,
      username: '',
      menu: [
        {
          label: 'Quản lý admin',  image: window.origin + '/assets/images/menu/User-2.svg', to: '/admin/list-manager', id: 'list_manager', hidden: this.show_list_menu_admin('list_manager')
        },
        {
          label: 'Quản lý văn bản', image: window.origin + '/assets/images/menu/pa.svg', hidden: this.show_list_menu_admin('parent_doc'),
          items: [
            {
              label: 'Nhập văn bản', icon: 'record-icon', to: '/admin/import-document', id: 'import_document', hidden: this.show_list_menu('insert_document')
            },
            {
              label: 'Danh sách tổng hợp văn bản', icon: 'record-icon', to: '/admin/list-document', id: 'list_document', hidden: this.show_list_menu('list_document')
            },
            {
              label: 'Bảng kê chi tiết văn bản', icon: 'record-icon', to: '/admin/statement-detail', id: 'statement_detail', hidden: this.show_list_menu('detail_document')
            }
            ,
            {
              label: 'Báo cáo VB tổng hợp nhân viên', icon: 'record-icon', to: '/admin/report-docs-tdv', id: 'report_docs_tdv', hidden: this.show_list_menu('report_docs_tdv')
            }
            ,
            {
              label: 'Báo cáo tổng hợp VB tồn nhân viên', icon: 'record-icon', to: '/admin/report-general-employee-inventory', id: 'report_general_employee_inventory', hidden: this.show_list_menu('report_general_employee_inventory')
            }
            ,
            {
              label: 'Bảng kê văn bản trả tòa', icon: 'record-icon', to: '/admin/statement-return-court', id: 'statement_return_court', hidden: this.show_list_menu('court_document')
            }
          ]
        },
        {
          label: 'Quản lý lương', image: window.origin + '/assets/images/menu/ic- money.svg', hidden: this.show_list_menu_admin('parent_salary'),
          items: [
            {
              label: 'Xác nhận văn bản tính lương', icon: 'record-icon', to: '/admin/compute-salary', id: 'compute_salary', hidden: this.show_list_menu('confirm_salary_document')
            },
            {
              label: 'Lương văn bản đi tỉnh', icon: 'record-icon', to: '/admin/compute-salary-outbound', id: 'compute_salary_outbound', hidden: this.show_list_menu('list_document_province')
            },
            {
              label: 'Bảng lương nhân viên', icon: 'record-icon', to: '/admin/payroll-employee', id: 'payroll_employee', hidden: this.show_list_menu('employee_payroll')
            }
          ]
        },
        {
          label: 'Cài đặt bảng giá', image: window.origin + '/assets/images/menu/Price.svg', hidden: this.show_list_menu_admin('parent_pricelist'),
          items: [
            {
              label: 'Bảng giá cơ quan', icon: 'record-icon', to: '/admin/list-organ_pricelist', id: 'list_organ_pricelist', hidden: this.show_list_menu('organ_pricelist')
            },
            {
              label: 'Bảng giá tỉnh', icon: 'record-icon', to: '/admin/list-organ_pricelist_province', id: 'list_organ_pricelist_province', hidden: this.show_list_menu('organ_pricelist_province')
            }
          ]
        },
        {
          label: 'Cài đặt bảng giá tính lương', image: window.origin + '/assets/images/menu/salary.svg', hidden: this.show_list_menu_admin('parent_setting_pricelist'),
          items: [
            {
              label: 'Bảng giá tính lương', icon: 'record-icon', to: '/admin/list-salary_pricelist', id: 'list_salary_pricelist', hidden: this.show_list_menu('salary_pricelist')
            },
            {
              label: 'Bảng giá tỉnh (VP liên kết)', icon: 'record-icon', to: '/admin/list-salary_pricelist_province', id: 'list_salary_pricelist_province', hidden: this.show_list_menu('salary_pricelist_provice')
            }
          ]
        },
        // {
        //   label: 'Cài đặt bảng giá', icon: 'fas fa-cog',
        //   items: [
        //     {
        //       label: 'Bảng giá cơ quan', icon: 'record-icon', to: '/admin/list-manager', id: 'list_manager'
        //     },
        //     {
        //       label: 'Bảng giá tỉnh', icon: 'record-icon', to: '/admin/list-manager', id: 'list_manager'
        //     }
        //   ]
        // },
        {
          label: 'Cài đặt ngày nghỉ', image: window.origin + '/assets/images/menu/XMLID_707_.svg', to: '/admin/list-holiday_setting', id: 'holiday_setting', hidden: this.show_list_menu('holiday_setting')
        },
        {
          label: 'Cài đặt trễ hẹn văn bản', image: window.origin + '/assets/images/menu/Group-780.svg', to: '/admin/list-status_tongdat/add', id: 'status_tongdat', hidden: this.show_list_menu('delay_document_setting')
        },
        {
          label: 'Thống kê báo cáo', image: window.origin + '/assets/images/menu/dashbroad.svg', hidden: this.show_list_menu_admin('parent_report'),
          items: [
            {
              label: 'Báo cáo VB hoàn thành trễ', icon: 'record-icon', to: '/admin/report-complete-late', id: 'report_late_done', hidden: this.show_list_menu('report_late_done')
            },
            {
              label: 'Báo cáo VB chưa hoàn thành trễ', icon: 'record-icon', to: '/admin/report-uncomplete-late', id: 'report_late_undone', hidden: this.show_list_menu('report_late_undone')
            },
            {
              label: 'Báo cáo VB đối chiếu với các CQ', icon: 'record-icon', to: '/admin/report-comparison', id: 'report_compare', hidden: this.show_list_menu('report_compare')
            },
            {
              label: 'Báo cáo VB tổng hợp các CQ', icon: 'record-icon', to: '/admin/report-comparison-agency', id: 'report_compare_agency', hidden: this.show_list_menu('report_compare_agency')
            }
          ]
        },
        {
          label: 'Quản lý thông báo', image: window.origin + '/assets/images/menu/Notication.svg', to: '/admin/list-notification', id: 'list_notification', hidden: this.show_list_menu('push_notification')
        },
        {
          label: 'Quản lý người dùng', image: window.origin + '/assets/images/menu/User-2.svg', hidden: this.show_list_menu_admin('parent_user'),
          items: [
            {
              label: 'Danh sách quản lý - ĐPV', icon: 'record-icon', to: '/admin/list-users_dpv', id: 'list_users_dpv', hidden: this.show_list_menu('list_coordinator')
            },
            {
              label: 'Danh sách Tống Đạt Viên', icon: 'record-icon', to: '/admin/list-users_tdv', id: 'list_users_tdv', hidden: this.show_list_menu('list_circulator')
            },
            {
              label: 'Danh sách tài khoản tòa', icon: 'record-icon', to: '/admin/list-court_account', id: 'list_court_account', hidden: this.show_list_menu('list_court_account')
            },
          ]
        },
        {
          label: 'Quản trị hệ thống', image: window.origin + '/assets/images/menu/setting.svg', hidden: this.show_list_menu_admin('parent_system'),
          items: [
            {
              label: 'Quản lý văn phòng', icon: 'record-icon', to: '/admin/list-office_tpl', id: 'list_office_tpl', hidden: this.show_list_menu('list_office')
            },
            {
              label: 'Quản lý khu vực', icon: 'record-icon', to: '/admin/list-area', id: 'list_area', hidden: this.show_list_menu('list_area')
            },
            {
              label: 'Quán lý cơ quan', icon: 'record-icon', to: '/admin/list-office_agency', id: 'list_office_agency', hidden: this.show_list_menu('list_organization')
            },
            {
              label: 'Quản lý văn phòng liên kết', icon: 'record-icon', to: '/admin/list-office_vplk', id: 'list_office_vplk', hidden: this.show_list_menu('list_affiliate_office')
            }
          ]
        },
        {
          label: 'Phân quyền', image: window.origin + '/assets/images/menu/Group-781.svg', to: '/admin/list-group_permission', id: 'list_manager', hidden: this.show_list_menu_admin('parent_group_permission')
        },
      ]
    }
  },
  apollo: {
			data: {
				query() { return DataServices.getList('accounts', {"fields" : "id, account, type, users {fullname}"}) },
        variables: {
            where_key: {
              id : {'_eq' : store.getters.user}
            }
          },
				update(data) {
					if (data.accounts) {
						// this.$store.commit('setRole', data.admin[0].role)
						this.username = data.accounts[0].users.fullname
					} else {
						this.username = ''
					}
				},
				skip(){
					if (this.$store.getters.user) {
						return false
					} else {
						return true
					}
				}
			},
		}
}
</script>

<style lang="scss">
.manager-title { color: #1D3118; text-transform: capitalize; font-size: 18px; margin-bottom: 16px; padding-bottom: 10px; border-bottom: 1px solid #EEEEEE;}
.p-column-filter {
  width: 100%;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

 .p-datepicker {
  min-width: 25rem;

  td {
    font-weight: 400;
  }
}

.p-paginator {
  .p-paginator-current {
    margin-left: 10px;
    margin-right: auto;
  }

  .p-dropdown {
    margin-left: auto;
    margin-right: 10px;
  }
}

.p-datatable.p-datatable-responsive {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
    border: 0 none;
    background: #fff;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-responsive .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.dropbtn {
  background-color: #3498DB;
  color: white;
  padding: 16px;
  font-size: 16px;
  border: none;
  cursor: pointer;
}

/* Dropdown button on hover & focus */
.dropbtn:hover, .dropbtn:focus {
  background-color: #2980B9;
}

/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}
.dropdown-content a:hover {background-color: #ddd}
.show {display:block;}
.layout-sidebar{width: 320px;}
.layout-menu {
  li {
    a { 
      span{ font-size: 16px; font-family: 'Roboto', sans-serif; margin-left: 8px; line-height: 24px;} 
    }
  }
}
.doc-header{
  strong{font-size: 24px; font-family: 'Roboto', sans-serif; text-transform: initial; font-weight: bold;}
}
.card-w-title {
  .manager-title{font-size: 24px; font-family: 'Roboto', sans-serif; text-transform: initial; font-weight: bold;}
}
.p-datatable table{table-layout: fixed !important; }
@media (min-width: 1025px) {
  .layout-wrapper {
    &.layout-static {
      .layout-topbar { left: 320px;}
      .layout-main, .layout-footer {margin-left: 320px;}
    }
  }
}
</style>
